import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Realmente funciona en 7 días?',
  a: 'Sí, porque no buscamos cambiar su personalidad, sino cambiar la dinámica de la casa para que la comunicación sea posible. Al cambiar tus reacciones, él se ve obligado a cambiar las suyas.'
}, {
  q: '¿Y si mi hijo no quiere cooperar?',
  a: 'Este método está diseñado para que funcione incluso si él no sabe que estás aplicando un plan. Tú tienes el control de tus acciones, y eso es suficiente para transformar el ambiente.'
}, {
  q: '¿Es difícil de aplicar?',
  a: 'Son micro-acciones. Pequeños cambios en tus palabras y gestos que no te tomarán más de 5 minutos al día. Está diseñado específicamente para madres ocupadas y agotadas.'
}, {
  q: '¿Funciona también con hijas adolescentes?',
  a: 'Absolutamente. El método está diseñado para mejorar la comunicación con cualquier adolescente, sea hijo o hija. Las dinámicas de desconexión emocional son similares y las micro-acciones funcionan igual de bien en ambos casos.'
}, {
  q: '¿Qué pasa si ya probé de todo y nada funcionó?',
  a: 'Justamente por eso creamos este método. A diferencia de los consejos genéricos, este sistema trabaja con la neurociencia del cerebro adolescente. No se trata de repetir lo mismo con más fuerza, sino de cambiar completamente el enfoque. Muchas madres que "ya habían probado todo" vieron resultados desde el día 3.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-24 bg-maternal-beige" data-id="element-22">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-23">
        <div className="text-center mb-8 md:mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold text-maternal-brown mb-4" data-id="element-25">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white rounded-2xl shadow-sm border border-maternal-cream overflow-hidden" data-id="element-27">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-28">
                  <span className="font-bold text-lg text-maternal-brown pr-4" data-id="element-29">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-maternal-amber transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-30" />
                </button>

                <AnimatePresence data-id="element-31">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-32">
                      <div className="px-6 pb-6 text-maternal-lightBrown leading-relaxed border-t border-maternal-cream pt-4" data-id="element-33">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}